import React from 'react'
import { KycProvider } from '@kyc-ui/react'
import { theme } from 'src/theming/theme'

const ThemeWrapper: React.FC = ({ children }) => {
  return <KycProvider theme={theme()}>{children}</KycProvider>
}

export default ThemeWrapper
